import React, { useEffect, useState } from 'react';

import { Box, Button, Container, Divider, Grid, Paper, Stack, Typography } from '@mui/material';
import AnimationPage from '../AnimationPage';
import BreadCrumb from '../../components/bread-crumb';
import { FormInputText } from '../../form-components/FormInputText';
import { useForm } from 'react-hook-form';
import { FormInputRadio } from '../../form-components/FormInputRadio';
import { businessDivision } from '../../constants/constants';
import { mainCallerWithOutToken } from '../../api/mainCaller';
import { getCoordinatesByAddress } from '../../api/nominatium';
import { useDaumPostcodePopup } from 'react-daum-postcode';
import { useToast } from 'use-toast-mui';
import { errorMessages } from '../../utils/methods';

export default function SectionThree({ setSection, managerInfo }) {
  const toast = useToast();
  const [postalCode, setPostalCode] = useState('');
  const [city, setCity] = useState('');

  const scriptUrl = 'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
  const open = useDaumPostcodePopup(scriptUrl);

  const { control, handleSubmit, setValue } = useForm({
    defaultValues: managerInfo,
  });

  const onSubmit = async values => {
    const data = {
      managerInfo: {
        username: managerInfo.username,
        name: managerInfo.name,
        password: managerInfo.password,
        phoneNumber: managerInfo.phoneNumber,
        email: managerInfo.email,
      },
      centerInfo: {
        businessName: values.businessName,
        businessNumber: values.businessNumber,
        businessClassification: values.businessClassification,
        businessType: values.businessType,
        postalCode: postalCode,
        city: city,
        address: values.jibunAddress,
        addressDetail: values.addressDetail,
        representativeNumber: values.representativeNumber,
        email: values.email_1,
        homepage: values.homepage,
        latitude: values.latitude,
        longitude: values.longitude,
      },
    };

    try {
      await mainCallerWithOutToken('admin/api/v1/auth/register', 'POST', data);
      toast.success('회원 가입 신청 완료되었습니다');
      setSection(4);
    } catch (error) {
      toast.error(errorMessages(error));
    }
  };

  // useEffect(() => {
  // reset(centerInfo);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [centerInfo]);

  const handleComplete = async data => {
    // setValue('city', data.sigungu);
    // 사용자가 선택한 주소 타입에 따라 도로명/지번 주소 설정
    setValue('jibunAddress', data.userSelectedType === 'R' ? data.roadAddress : data.jibunAddress);
    // setValue('postalCode', data.zonecode);
    setPostalCode(data.zonecode);
    setCity(data.sigungu);

    await getCoordinatesByAddress(data.addressEnglish).then(data => {
      // setCity(data[0].address.addressCity);
      setValue('latitude', data[0].coordinate.latitude);
      setValue('longitude', data[0].coordinate.longitude);
      setValue('city', data.sido);
      setValue('region', data.sigungu);
      // setAddress(data[0].address.addressLine1);
      // setValue('jibunAddress', data[0].address.addressLine1);
    });
  };

  const handleClick = () => {
    open({ onComplete: handleComplete });
  };

  useEffect(() => {
    setValue('businessClassification', 'INDIVIDUAL');
  }, []);

  return (
    <form action="" onSubmit={handleSubmit(onSubmit)}>
      <AnimationPage>
        <Box
          sx={{
            mt: 6,
            ml: 7,
          }}>
          <img src="/images/logo/logoo.svg" alt="logo" />

          <Container maxWidth="lg" sx={{ mt: 13.5 }}>
            {/* <BreadCrumb crumbName3={'매장 정보 입력'} /> */}
            <Paper
              sx={{
                // color: theme.palette.info.main,
                boxShadow: '0px 0px 7px #0000001A',
                borderRadius: '10px',
                elevation: 3,
                py: 6,
                px: 7.5,
              }}>
              <Typography
                sx={{
                  fontSize: '30px',
                  lineHeight: '35.8px',
                  fontWeight: 700,
                }}>
                사업자 정보 입력
              </Typography>

              <Divider sx={{ border: '1px solid #E7E7E7', mt: '37px', mb: '33px' }} />

              <Grid container columnSpacing={16} sx={{ justifyContent: 'space-between' }}>
                <Grid item xs={6}>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Grid item xs={3}>
                      <Typography sx={{ fontSize: '13px', fontWeight: 500, lineHeight: '24px' }}>
                        사업자 명(필수)
                      </Typography>
                    </Grid>
                    <Grid item xs={9}>
                      <FormInputText
                        className="input-large"
                        name="businessName"
                        control={control}
                        rules={{ required: true }}
                        placeholder="사업자 명을 입력해 주세요"
                      />
                    </Grid>
                  </Box>

                  <Box sx={{ display: 'flex', alignItems: 'center', my: 3.25 }}>
                    <Grid item xs={3}>
                      <Typography sx={{ fontSize: '13px', fontWeight: 500, lineHeight: '24px' }}>
                        사업자 번호(필수)
                      </Typography>
                    </Grid>
                    <Grid item xs={9}>
                      <FormInputText
                        className="input-large"
                        name="businessNumber"
                        rules={{ required: true }}
                        control={control}
                        placeholder="사업자 번호를 입력해 주세요"
                      />
                    </Grid>
                  </Box>

                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Grid item xs={3}>
                      <Typography sx={{ fontSize: '13px', fontWeight: 500, lineHeight: '24px' }}>
                        사업자 구분
                      </Typography>
                    </Grid>
                    <Grid item xs={9}>
                      <FormInputRadio name="businessClassification" control={control} options={businessDivision} row />
                    </Grid>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', mt: 3.25 }}>
                    <Grid item xs={3}>
                      <Typography sx={{ fontSize: '13px', fontWeight: 500, lineHeight: '24px' }}>
                        업태/종목(필수)
                      </Typography>
                    </Grid>
                    <Grid item xs={9}>
                      <FormInputText
                        className="input-large"
                        name="businessType"
                        control={control}
                        placeholder="업태/종목을 입력해 주세요"
                        rules={{ required: true }}
                      />
                    </Grid>
                  </Box>

                  <Box sx={{ display: 'flex', alignItems: 'center', my: 3.25 }}>
                    <Grid item xs={3}>
                      <Typography sx={{ fontSize: '13px', fontWeight: 500, lineHeight: '24px' }}>주소(필수)</Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <FormInputText
                        className="input-large"
                        name="jibunAddress"
                        control={control}
                        rules={{ required: true }}
                        placeholder="주소/우편번호 검색"
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <Button
                        onClick={handleClick}
                        variant="contained"
                        color="primary"
                        sx={{
                          height: 40,
                          bgcolor: '#F8FBFB',
                          boxShadow: 'none',
                          color: '#0F7F85',
                          fontSize: '13px',
                          fontWeight: 500,
                          lineHeight: '15.51px',
                          ml: 1,
                          '&:hover': { color: '#fff' },
                        }}>
                        검색
                      </Button>
                    </Grid>
                  </Box>

                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Grid item xs={3}></Grid>
                    <Grid item xs={9}>
                      <FormInputText
                        className="input-large"
                        name="addressDetail"
                        control={control}
                        placeholder="상세 주소를 입력해 주세요"
                      />
                    </Grid>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Grid item xs={2.5}>
                      <Typography sx={{ fontSize: '13px', fontWeight: 500, lineHeight: '24px' }}>
                        대표번호(필수)
                      </Typography>
                    </Grid>
                    <Grid item xs={10}>
                      <FormInputText
                        className="input-large"
                        name="representativeNumber"
                        rules={{ required: true }}
                        control={control}
                        placeholder="대표번호를 입력해 주세요"
                      />
                    </Grid>
                  </Box>

                  <Box sx={{ display: 'flex', alignItems: 'center', my: 3.25 }}>
                    <Grid item xs={2.5}>
                      <Typography sx={{ fontSize: '13px', fontWeight: 500, lineHeight: '24px' }}>
                        이메일(필수)
                      </Typography>
                    </Grid>
                    <Grid item xs={9.5}>
                      <FormInputText
                        className="input-large"
                        name="email_1"
                        control={control}
                        type="email"
                        rules={{ required: true }}
                        placeholder="이메일을 입력해주세요"
                      />
                    </Grid>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', my: 3.25 }}>
                    <Grid item xs={2.5}>
                      <Typography sx={{ fontSize: '13px', fontWeight: 500, lineHeight: '24px' }}>
                        홈페이지(선택)
                      </Typography>
                    </Grid>
                    <Grid item xs={10}>
                      <FormInputText
                        className="input-large"
                        name="homepage"
                        control={control}
                        placeholder="홈페이지 주소를 입력해 주세요"
                      />
                    </Grid>
                  </Box>
                </Grid>
              </Grid>

              <Divider sx={{ border: '1px solid #E7E7E7', mt: '32px', mb: '25px' }} />

              <Stack sx={{ flexDirection: 'row', justifyContent: 'end' }}>
                <Button
                  variant="contained"
                  color="secondary"
                  sx={{
                    color: '#fff',
                    borderRadius: '5px',
                    height: 40,
                    minWidth: 125,
                    boxShadow: 'none',
                    mr: 1,
                  }}
                  onClick={() => setSection(2)}>
                  뒤로가기
                </Button>
                <Button variant="contained" color="primary" sx={{ borderRadius: '5px', minWidth: 183 }} type="submit">
                  다음
                </Button>
              </Stack>
            </Paper>
          </Container>
        </Box>
      </AnimationPage>
    </form>
  );
}
